import { useEffect, useState } from 'react';
import useSessionManager from '../../../HOC/TokenHandler/useSessionManager';
import { useGetDashboardData } from '../views/dashboard/hooks/useGetDashboardData';

const useTopbarDefaultProps = () => {
  const { account, onOrgSelected } = useGetDashboardData();
  const [clearSession] = useSessionManager();
  const [orgs, setOrgs] = useState([]);

  useEffect(() => {
    if (account?.organizations?.length) {
      const accountOrgs = account?.organizations?.map(
        ({
          provider_organization_name,
          provider_organization_id,
          organization_avatar_url,
          gitstream_account_id
        }) => {
          return {
            isSelected:
              provider_organization_id ===
              account.current_provider_organization_id,
            name: provider_organization_name,
            imageUrl: organization_avatar_url,
            id: provider_organization_id,
            gitstream_account_id: gitstream_account_id
          };
        }
      );
      setOrgs(accountOrgs);
    }
  }, [account]);

  const provider = account.git_connector_name;

  return {
    username: account.account_name ?? '',
    email: account.email ?? '',
    imageUrl: account.avatar_url ?? '',
    onOrgSelected,
    onLogoutClick: (redirectToLogin = true) => clearSession(redirectToLogin),
    orgs,
    loggedIn: Boolean(Object.keys(account).length),
    provider
  };
};

export default useTopbarDefaultProps;
